import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Auth.css";
import backgroundImage from "../assets/imagem-prefeitura.jpg";
import { FaEnvelopeOpenText } from "react-icons/fa";
import api from "../services/api";
import ToastContext from "../contexts/ToastContext";
import VerificationNoticeModal from "../components/VerificationNoticeModal";

function AguardandoVerificacao() {
  const { addToast } = useContext(ToastContext);
  const location = useLocation();
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [resendHelperText, setResendHelperText] = useState("");

  useEffect(() => {
    const shouldOpen = !!location.state?.showVerificationModal;
    const emailFromState = (location.state?.registeredEmail || "").trim();
    if (emailFromState) setRegisteredEmail(emailFromState);

    if (shouldOpen) {
      setShowVerificationModal(true);
      // Cooldown visual: o backend também bloqueia reenvio imediato.
      setResendDisabled(true);
      setResendHelperText(
        "Email enviado. Aguarde 10 minutos para solicitar reenvio."
      );
      setTimeout(() => {
        setResendDisabled(false);
        setResendHelperText("");
      }, 10 * 60 * 1000);
    }
  }, [location.state]);

  return (
    <div
      className="auth-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <VerificationNoticeModal
        isOpen={showVerificationModal}
        onClose={() => {
          setShowVerificationModal(false);
          setResendDisabled(false);
          setResendHelperText("");
        }}
        onResend={async () => {
          const trimmedEmail = (registeredEmail || "").trim();
          if (!trimmedEmail) {
            addToast(
              "Email não encontrado. Volte ao cadastro e tente novamente.",
              "error"
            );
            return;
          }

          try {
            setResendDisabled(true);
            setResendHelperText("Solicitando reenvio...");
            await api.post("/auth/resend-verification", { email: trimmedEmail });
            addToast("Email reenviado com sucesso!", "success");

            setResendHelperText(
              "Reenvio solicitado. Aguarde 10 minutos para tentar novamente."
            );
            setTimeout(() => {
              setResendDisabled(false);
              setResendHelperText("");
            }, 10 * 60 * 1000);
          } catch (error) {
            const message =
              error.response?.data?.message || "Não foi possível reenviar o email.";
            addToast(message, "error");

            const retryAfter = Number(error.response?.data?.retryAfterSeconds || 0);
            if (retryAfter > 0) {
              setResendHelperText(
                `Aguarde ${Math.ceil(retryAfter / 60)} minuto(s) para tentar novamente.`
              );
              setTimeout(() => {
                setResendDisabled(false);
              }, retryAfter * 1000);
              return;
            }

            setResendDisabled(false);
            setResendHelperText("");
          }
        }}
        resendDisabled={resendDisabled}
        resendHelperText={resendHelperText}
      />
      <div className="auth-card auth-card-centered">
        <FaEnvelopeOpenText className="auth-icon" />
        <h1>Verifique seu Email</h1>
        <p className="auth-message">
          Enviamos um link de verificação para o seu endereço de email. Por
          favor, clique no link para ativar sua conta.
        </p>
        <div className="form-actions full-width">
          <Link to="/login" className="btn-modern">
            Voltar para o Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AguardandoVerificacao;
